import { Layout } from '@/core/layout/layout';
import { LEGACY_PROCESS_VIEW_ROUTE, processDetailsRoutes } from '@/features/client/process-details';
import { type RouteRecordRaw } from 'vue-router';

/**
 * One URL, two views. `ProcessViewResolver` reads the rollout flag and renders either
 * the legacy process view or the process details view; the children below supply the
 * matched page for whichever wins, and their own `layout` meta (last match wins in
 * `AppLayoutRoot`) gives each variant the chrome it expects.
 *
 * The path and the `incorporation` route name are fixed: absolute URLs built from them
 * live in backend records and in sent mail. See
 * `docs/adr/0019-process-details-view-mounts-under-incorporation-id.md`.
 */
export default {
    path: '/incorporation/:id',
    component: () => import('@/features/client/process-details/ProcessViewResolver.vue'),
    meta: {
        private: true,
        layout: Layout.Blank,
    },
    children: [
        {
            path: '',
            name: LEGACY_PROCESS_VIEW_ROUTE,
            component: () => import('@/components/Client/Incorporation/Incorporation.vue'),
            meta: { layout: Layout.HeaderOnly },
        },
        ...processDetailsRoutes,
        {
            path: ':pathMatch(.*)',
            redirect: { name: LEGACY_PROCESS_VIEW_ROUTE },
        },
    ],
} as RouteRecordRaw;
